import React from "react"

import { ProjectActionsOverlay } from "widgets/project/project-actions-overlay/ProjectActionsOverlay"
import { ProjectActionsOverlayPayload } from "widgets/project/project-actions-overlay/ProjectActionsOverlayConnector"

import { useSharedProjectActionsOverlayModel } from "./hooks/useSharedProjectActionsOverlayModel"

export interface SharedProjectActionsOverlayPayload
  extends ProjectActionsOverlayPayload {
  projectShareID: string
}

export interface SharedProjectActionsOverlayConnectorProps {
  payload: SharedProjectActionsOverlayPayload
}

export const SharedProjectActionsOverlayConnector = React.memo(
  (props: SharedProjectActionsOverlayConnectorProps) => (
    <ProjectActionsOverlay
      isShared
      {...useSharedProjectActionsOverlayModel(props)}
    />
  )
)

declare module "shared/context/overlay/registry" {
  interface OverlayPayloadRegistry {
    SHARED_PROJECT_ACTIONS_OVERLAY: SharedProjectActionsOverlayPayload
  }
}
